import { FC } from "react";
import cx from "classnames";

type Props = {
  label?: string;
  name: string;
  options: { value: string; label?: string }[];
  required?: boolean;
  error?: string;
  value?: string;
  placeholder?: string;
  defaultValue?: string;
  helperText?: string;
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  disabled?: boolean;
  size?: "sm" | "md" | "lg";
  widthFull?: boolean;
};

const SelectInput: FC<Props> = ({
  label,
  name,
  error,
  value,
  required,
  placeholder,
  defaultValue,
  options,
  onChange,
  helperText,
  disabled,
  size = "md",
  widthFull = true,
}) => {
  return (
    <label className={cx("form-control", { "w-full": widthFull })}>
      {label && <div className="label">
        <span className="label-text">{label}</span>
      </div>}
      <select
        id={name}
        name={name}
        required={required}
        value={value}
        className={cx("select", {
          "select-sm": size === "sm",
          "select-md": size === "md",
          "select-lg": size === "lg",
        })}
        defaultValue={defaultValue}
        onChange={onChange}
        disabled={disabled}
      >
        {placeholder && <option value="">{placeholder}</option>}
        {options.map((option, idx) => (
          <option key={`${option.value}__${idx}`} value={option.value}>
            {option.label || option.value}
          </option>
        ))}
      </select>
      {(helperText || error) && (
        <div className="label">
          {helperText && <span className="label-text-alt">{helperText}</span>}
          {error && <span className="label-text-alt text-error">{error}</span>}
        </div>
      )}
    </label>
  );
};

export default SelectInput;
